var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site"},[_c('SiteHeader',{staticClass:"site__header"}),_vm._t("default"),_c('SiteFooter',{staticClass:"site__footer"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }